import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';

import paths from '@/lib/paths';

import type { Policy } from '../../types';
import { dueDateToReadable, formatPremiumWithInterval } from '../../utils';

type Props = {
  policy: Policy;
};

export default function PolicyItem({ policy }: Props) {
  const { t } = useTranslation();

  return (
    <Link
      to={generatePath(paths.policies.detail, { id: policy.id })}
      className="shadow-card flex flex-col gap-2 rounded-lg border p-2"
    >
      <div className="flex flex-col text-sm">
        <span className="flex items-center gap-1 leading-tight">
          <Shield className="size-3.5" />

          {policy.name}
        </span>

        <span className="text-muted-foreground text-xs">
          {policy.policy_nr}
        </span>
      </div>

      <div className="grid grid-cols-2">
        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('Vervaldatum')}
          </span>

          <span className="text-sm leading-tight">
            {dueDateToReadable(policy.due_date) ?? '-'}
          </span>
        </div>

        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('Premie per termijn')}
          </span>

          <span className="text-sm leading-tight">
            {formatPremiumWithInterval(
              policy.premium,
              policy.payment_interval,
              t,
            ) ?? '-'}
          </span>
        </div>
      </div>
    </Link>
  );
}
